export class EstAuthError extends Error {
  constructor (name: string = 'Authentication failed', message: string = 'Please try again') {
    super(message);
    this.name = name;
  }
}
